
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"watchRequestStatusMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchRequestStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fileRunRequest"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileRunRequestItem"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pbmName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rateCodeDesc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specialtyUploadId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formularyUploadId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"networkUploadId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lddPricingUploadId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specialtyList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"formulary"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"network"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lddPricing"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fileRunRequestItemDetail"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rulesRaw"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priorityId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileUploadId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isListRule"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rules"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priority"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fileUpload"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"listType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":799}};
    doc.loc.source = {"body":"#import '../fragments/file-run-request'\n\nmutation watchRequestStatusMutation (\n  $ids: [ID]\n) {\n  watchRequestStatus (\n    ids: $ids\n  ) {\n    ...fileRunRequest\n    fileRunRequestItem {\n      id\n      pbmName\n      rateCodeDesc\n      specialtyUploadId\n      formularyUploadId\n      networkUploadId\n      lddPricingUploadId\n      specialtyList {\n        fileName\n      }\n      formulary {\n        fileName\n      }\n      network {\n        fileName\n      }\n      lddPricing {\n        fileName\n      }\n      fileRunRequestItemDetail {\n        rulesRaw\n        priorityId\n        listTypeId\n        fileUploadId\n        isListRule\n        rules\n        priority {\n          value\n        }\n        fileUpload {\n          fileName\n        }\n        listType {\n          value\n        }\n      }\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../fragments/file-run-request').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["watchRequestStatusMutation"] = oneQuery(doc, "watchRequestStatusMutation");
        
